import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { SectionProps } from '../../../../../type/manage';

const Section = ({ title, children }: SectionProps) => (
  <Accordion sx={{ boxShadow: 'none', border: 'none', '&:before': { display: 'none' } }} defaultExpanded>
    <AccordionSummary className="px-0 border-none" expandIcon={<ChevronRightIcon />}>
      <div className="flex items-center w-full">
        <span className="text-lg font-medium text-nowrap mr-2">{title}</span>
        <hr className="block w-full" />
      </div>
    </AccordionSummary>
    <AccordionDetails sx={{ p: 0 }}>{children}</AccordionDetails>
  </Accordion>
);

export default Section;